<nav class="cabin-tab-bar" aria-label="Navegación modo cabina">
  @for (t of tabs; track t.link) {
    <a
      matRipple
      class="cabin-tab"
      [routerLink]="t.link"
      [queryParams]="t.queryParams"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
    >
      <i-tabler [name]="t.icon" class="icon-20 cabin-tab-icon"></i-tabler>
      <span class="cabin-tab-label">{{ t.label }}</span>
    </a>
  }
</nav>
